module.exports = __webpack_public_path__ + "static/media/iamthatiam3.ec56963e.jpg";